module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit_date_time":"Edit date and time","select_pick_up_date":"Select pick up date and time","asap":"ASAP","schedule":"SCHEDULE"},"id":{"edit_date_time":"Ubah tanggal dan waktu","select_pick_up_date":"Pilih tanggal dan waktu pengambilan","asap":"Secepat Mungkin","schedule":"JADWAL"}}')
  delete Component.options._Ctor
}
